import { render, staticRenderFns } from "./AdminDrawerDetail.vue?vue&type=template&id=76354805"
import script from "./AdminDrawerDetail.vue?vue&type=script&lang=js"
export * from "./AdminDrawerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports